import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { SubtypeExamService } from '../../../core/services/subtype-exam/subtype-exam/subtype-exam.service'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import {TariffService} from '../../../core/services/tariff/tariff/tariff.service';
import {TariffTypeService} from '../../../core/services/tariff/tariff-type/tariff-type.service';
import {ExamTypeService} from '../../../core/services/exam-type/document-type/exam-type.service';

@Component({
  selector: 'subtype-exam-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelectModule,
    MatSlideToggle,
  ],
  templateUrl: './subtype-exam-create.component.html',
  styleUrl: './subtype-exam-create.component.scss',
  providers: [SubtypeExamService],
  standalone: true,
})
export class SubtypeExamCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private serviceSpecificationService: SubtypeExamService,
    private examTypeService: ExamTypeService,
    private snackbar: SnackbarCustomService,
  ) {}

  @Output() responseCreate = new EventEmitter()

  form: FormGroup = new FormGroup({})
  loading: boolean = false
  listType: any[] = []

  ngOnInit(): void {
    this.createForm()
    this.listTypeService()
  }

  listTypeService() {
    this.examTypeService.listExamType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  createItem() {
    this.loading = true
    const model = this.createModel()
    this.serviceSpecificationService
      .createSubTypeExam(model)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.responseCreate.emit()
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
          this.form.reset()
        },
      })
  }

  createModel() {
    return {
      descricao: this.form.controls['description'].value,
      nome: this.form.controls['name'].value,
      tipo_exame_id: this.form.controls['typeExam'].value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      description: ['', [Validators.required]],
      typeExam: [null, [Validators.required]],
      name: ['', [Validators.required]],
    })
  }
}
